import { render, staticRenderFns } from "./SettingsProperty.vue?vue&type=template&id=85a9ea54&scoped=true&"
import script from "./SettingsProperty.vue?vue&type=script&lang=js&"
export * from "./SettingsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a9ea54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a9ea54')) {
      api.createRecord('85a9ea54', component.options)
    } else {
      api.reload('85a9ea54', component.options)
    }
    module.hot.accept("./SettingsProperty.vue?vue&type=template&id=85a9ea54&scoped=true&", function () {
      api.rerender('85a9ea54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/SettingsProperty.vue"
export default component.exports